import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`bg-white border border-forest/10 shadow-sm overflow-hidden ${className}`} {...props} data-id="element-196">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`px-6 py-5 border-b border-forest/10 ${className}`} {...props} data-id="element-197">
      {children}
    </div>;
}
export function CardContent({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 ${className}`} {...props} data-id="element-198">
      {children}
    </div>;
}
export function CardFooter({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`px-6 py-4 bg-cream/50 border-t border-forest/10 ${className}`} {...props} data-id="element-199">
      {children}
    </div>;
}